/* Tabela de rotas: "secao/pagina" → tela. */

import { categorias } from './analise/categorias';
import { evolucao } from './analise/evolucao';
import { fornecedores } from './analise/fornecedores';
import { meusGraficos } from './analise/meusGraficos';
import { montarGrafico } from './analise/montar';
import { obras } from './analise/obras';
import { config } from './config';
import { documentos } from './emissoes/documentos';
import { envios } from './emissoes/envios';
import { lancar } from './emissoes/lancar';
import { personalizada } from './emissoes/personalizada';
import { planilha } from './emissoes/planilha';
import { painel } from './painel';
import type { Pagina } from './pagina';
import { relatorioGhg } from './relatorios/ghg';
import { simulador } from './simulador';
import { listaRelatorios } from './relatorios/lista';

export const PAGINAS: Record<string, Pagina> = {
  'painel/visao': painel,
  'analise/categorias': categorias,
  'analise/evolucao': evolucao,
  'analise/obras': obras,
  'analise/fornecedores': fornecedores,
  'analise/montar': montarGrafico,
  'analise/graficos': meusGraficos,
  'emissoes/lancar': lancar,
  'emissoes/planilha': planilha,
  'emissoes/personalizada': personalizada,
  'emissoes/documentos': documentos,
  'emissoes/envios': envios,
  'simulador/calcular': simulador,
  'relatorios/lista': listaRelatorios,
  'relatorios/ghg': relatorioGhg,
  'config/geral': config,
};
